<template>
  <b-steps
    v-if="applicant && !loading"
    v-model="activeStep"
    :has-navigation="false"
    size="is-medium"
    :destroy-on-hide="true"
  >
    <b-step-item
      step="1"
      icon="shield-check"
      :label="$t('identity')"
      :type="applicant.is_identity_step_completed && activeStep != '0' ? 'is-success': 'is-gray'"
      :clickable="true"
    >
      <VApplicantIdentity
        v-if="activeStep == 0"
        :applicant="applicant"
        @success="onSuccessIdentity"
      />
    </b-step-item>
    <b-step-item
      step="2"
      icon="cash-check"
      :label="$t('finance')"
      :type="applicant.is_finance_step_completed && activeStep != '1' ? 'is-success': 'is-gray'"
      :clickable="true"
    >
      <VApplicantFinance
        v-if="activeStep == 1"
        :applicant="applicant"
        @success="onSuccessFinance"
      />
    </b-step-item>
    <b-step-item
      step="3"
      icon="bank-check"
      :type="applicant.is_credit_step_completed && activeStep != '2' ? 'is-success': 'is-gray'"
      :label="$t('credit')"
      :clickable="true"
    >
      <VApplicantCredit
        v-if="activeStep == 2"
        :applicant="applicant"
        :application-file="applicationFile"
        @success="onSuccessCredit"
      />
    </b-step-item>
  </b-steps>
</template>

<script>

import { i18n } from "@/services/i18n";
import ApplicantIdentity from "./components/ApplicantIdentity";
import ApplicantCredit from "./components/ApplicantCredit";
import ApplicantFinance from "./components/ApplicantFinance";

export default {
  components: {
    "VApplicantIdentity": ApplicantIdentity,
    "VApplicantCredit": ApplicantCredit,
    "VApplicantFinance": ApplicantFinance
  },
  props: {
    applicant: {
      default: null,
      type: Object
    },
    applicationFile: {
      default: null,
      type: Object
    },
    loading: {
      default: false,
      type: Boolean
    }
  },
  metaInfo() {
    return {
      title: i18n.t("application_files"),
    };
  },
  data() {
    return {
      model: null,
      activeStep: 0
    };
  },
  created() {
    let activeStep = 2;

    if (! this.applicant) {
      this.activeStep = 2;
      return;
    }

    if (! this.applicant.salary_type) {
      activeStep = 1;
    }

    if (! this.applicant.identity_type) {
      activeStep = 0;
    }

    this.activeStep = activeStep;
  },
  methods: {
    onSuccessIdentity() {
      if (this.loading) {
        return;
      }

      this.activeStep = 1;
      this.$emit("success");
    },
    onSuccessFinance() {
      if (this.loading) {
        return;
      }

      this.activeStep = 2;
      this.$emit("success");
    },
    onSuccessCredit() {
      if (this.loading) {
        return;
      }
      this.activeStep = 2;
      this.$emit("success");
    },
  }
};

</script>

<style>
.b-steps .steps .step-items .step-item:not(:first-child)::before, .b-steps .steps .step-items .step-item:only-child::before {
  background: transparent;
}
.b-steps .steps .step-items .step-item::before, .b-steps .steps .step-items .step-item::after{
  background: transparent;
}
.b-steps .steps .step-items .step-item.is-gray.is-active .step-marker {
  border-color: #4259ff !important;
  color: #fff !important;
  background-color: #4259ff !important;
}
.b-steps .steps .step-items .step-item.is-gray .step-marker
{
  background-color: #b8bdc6 !important;
  border-color: #b8bdc6 !important;
  color: #fff !important;
}

.b-steps .steps .step-items .step-item.is-success .step-marker {
  color: #fff !important;
  background-color: #059669 !important;
  border-color: #059669 !important;
}
.b-steps .steps .step-items .step-item.is-success.is-active .step-marker {
  background-color: #059669 !important;
  color: #fff !important;
}
</style>
